// Forecast API
import {
    ForecastFilterRequestResponse, ForecastObjectResponse,
} from 'app/requests/Forecast/Forecast.types'
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type ForecastRequests = {
    filterRequest: RequestConfigFunction<
        { params?: Record<string, any> },
        ForecastFilterRequestResponse
    >,
    get: RequestConfigFunction<{ id: number }, ForecastObjectResponse>,
    create: RequestConfigFunction,
}

const forecastRequests: ForecastRequests = {
    filterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'forecast/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `forecast/${id}`,
            method: 'GET',
        }
    },
    create: () => {
        return {
            url: 'forecast',
            method: 'POST',
        }
    },
}

export default forecastRequests
